/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class StatusGroup {

        public statusName: string;
        public stateGroups: StateGroup[];
        
        constructor(processStatusGroup: ProcessStatusGroup) {
            this.statusName = processStatusGroup.processStatusGroupDto.statusName;
            this.stateGroups = [];

            var stateWorkflowBlocks: StateWorkflowBlock[] = this.getAllStatesInOrder(processStatusGroup.workflowBlocks);
            for (var i = 0; i < stateWorkflowBlocks.length; i++) {
                this.stateGroups.push(new StateGroup(stateWorkflowBlocks[i], processStatusGroup.workflowBlocks));
            }
        }

        private getAllStatesInOrder(workflowBlocks: IWorkflowBlock[]): StateWorkflowBlock[] {
            var initialBlock = Enumerable.from(workflowBlocks).single(i => i.isInitialBlock);
            var stateWorkflowBlocks: StateWorkflowBlock[] = [];

            var currentBlock = initialBlock;
            var processedBlockIds: string[] = [];
            var pendingBlockIds: string[] = [];

            while (currentBlock !== undefined && currentBlock != null) {
                var nextBlock = undefined;
                var nextBlockId = undefined;

                if (processedBlockIds.indexOf(currentBlock.id) === -1) {
                    processedBlockIds.push(currentBlock.id);
                    if (currentBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.State) {
                        stateWorkflowBlocks.push(<StateWorkflowBlock>currentBlock);
                    }


                    // Set Next Block to Process
                    if (currentBlock.toBlockIds && currentBlock.toBlockIds.length > 0) {
                        nextBlockId = currentBlock.toBlockIds[0];
                        nextBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id == nextBlockId);
                        if (nextBlock) {
                            for (var i = 1; i < currentBlock.toBlockIds.length; i++) {
                                if (pendingBlockIds.indexOf(currentBlock.toBlockIds[i]) === -1) {
                                    pendingBlockIds.push(currentBlock.toBlockIds[i])
                                }
                            }
                        }
                    }
                }

                if (nextBlock === undefined && pendingBlockIds.length > 0) {
                    nextBlockId = pendingBlockIds.shift();
                    nextBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id == nextBlockId);
                }

                currentBlock = nextBlock;
            }
            return stateWorkflowBlocks;
        }
    }
}